<template>
  <div v-if="showButton">
    <button
      @click="$emit('enable-infinite-mode')"
      class="infinite-mode-button"
      title="Habilitar modo infinito: vidas y pistas ilimitadas"
    >
      ∞
    </button>
  </div>
</template>

<script>
export default {
  name: 'InfiniteMode',
  props: {
    showButton: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['enable-infinite-mode'],
  methods: {
    handleRulesClick() {
      this.$emit('toggle-rules', 'infinite-mode')
    },
  },
}
</script>

<style scoped>
.tooltip-text {
  visibility: hidden; /* Oculto por defecto */
  opacity: 0; /* Transparencia */
  position: absolute; /* Posición absoluta respecto al .tooltip */
  left: 50%; /* Centrar horizontalmente */
  background-color: #333; /* Fondo para el tooltip */
  color: #fff; /* Texto en blanco */
  padding: 8px;
  border-radius: 4px;
  font-size: 14px;
  transition:
    opacity 0.2s ease,
    visibility 0.2s ease;
  white-space: nowrap; /* Evita que se corte en varias líneas */
  z-index: 1; /* Para que aparezca por encima de otros elementos */
  transform: translateX(-50%) translateY(-15px);
}

.infinite-mode-button {
  background-color: white;
  border: none; /*2px solid #4CAF50; */
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  font-size: 38px;
  font-weight: bold;
  color: #4caf50;
  transition: all 0.2s;
  position: absolute;
  top: 15px;
  width: 36px;
  height: 39px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* .infinite-mode-button:hover {
  background-color: #4CAF50;
  color: white;
} */

.infinite-mode-button:active {
  transform: scale(0.95);
}

@media (max-width: 1200px) {
  .infinite-mode-button {
    right: 10px;
    top: 62px;
  }
}

@media (min-width: 1200px) {
  .infinite-mode-button {
    left: 110px;
  }
}
</style>
